// extracted by mini-css-extract-plugin
export default {"container":"App_container__mB9ij","content":"App_content__KtPRx","tabBar":"App_tabBar__MqwTX","tab":"App_tab__6jY-F"};